import { Box, CircularProgress } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Palette } from '@/themes/themeOverrides/Palette';
import { useTranslate } from 'react-admin';

export const ReferenceArrayFilterSpinner = () => {
    const translate = useTranslate();
    const theme = useTheme();
    return (
        <Box
            className='loading'
            sx={{
                minWidth: '170px',
                height: '48px',
                borderRadius: '12px',
                padding: '15px 20px',
                position: 'relative',
                fontSize: '11px',
                border: `2px solid ${Palette.gray.gray200}`,
                top: '-4px',
                display: 'flex',
                gap: '10px',
                [theme.breakpoints.down('md')]: {
                    fontFamily: 'Inter, Arial, sans-serif',
                    minHeight: '100px',
                    boxShadow: 'none !important',
                    border: 'none',
                    textAlign: 'center',
                    overflow: 'hidden',
                    position: 'static',
                },
                '& .MuiCircularProgress-root': {
                    width: '16px !important',
                    height: '16px !important',
                },
                '& + .MuiButtonBase-root.RaFilterFormInput-hideButton': { top: '10px' },
            }}
        >
            <CircularProgress /> {translate('common.loading')}
        </Box>
    );
};
